import { render, staticRenderFns } from "./fundamentacaoLegal.vue?vue&type=template&id=00915616&"
import script from "./fundamentacaoLegal.vue?vue&type=script&lang=js&"
export * from "./fundamentacaoLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports